import { DatadogTradingAction, trackCustomerOrderAction } from '@src/utils/datadogTradingActions';
import {
  Dialog,
  NotificationVariants,
  Put,
  type UseDisclosureWithContextReturn,
  useGlobalToasts,
  useUserContext,
} from '@talos/kyoko';
import { useCallback } from 'react';

interface CancelS2FCustomerOrderDialogProps extends UseDisclosureWithContextReturn<string> {}

export const CancelS2FCustomerOrderDialog = ({
  context: customerOrderID,
  ...props
}: CancelS2FCustomerOrderDialogProps) => {
  const { orgApiEndpoint } = useUserContext();
  const { add: addToast } = useGlobalToasts();

  const cancelOrder = useCallback(() => {
    trackCustomerOrderAction(DatadogTradingAction.ForceCancel, { orderID: customerOrderID });
    Put(orgApiEndpoint as string, `/customer/orders/${customerOrderID}/force-cancel`)
      .then(() => {
        addToast({
          text: `Order canceled.`,
          variant: NotificationVariants.Positive,
        });
      })
      .catch((e: ErrorEvent) =>
        addToast({
          text: `Could not cancel order: ${e.message}`,
          variant: NotificationVariants.Negative,
        })
      );
  }, [addToast, customerOrderID, orgApiEndpoint]);

  return (
    <Dialog
      {...props}
      confirmLabel="Cancel Order"
      cancelLabel="Close"
      title="Confirm cancellation"
      onConfirm={cancelOrder}
      width="400px"
      stretchButtons
    >
      Only cancel this order if you have confirmed with your client that this order is canceled on their side as well.
    </Dialog>
  );
};
